import { render, staticRenderFns } from "./ProductivitySummaryByAssignment.vue?vue&type=template&id=4a72ed16&"
import script from "./ProductivitySummaryByAssignment.vue?vue&type=script&lang=js&"
export * from "./ProductivitySummaryByAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports